var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 2C8.1 2 4.5 5.6 4.5 10C4.5 15.4 11.5 21.5 11.8 21.8C12 21.9 12.3 22 12.5 22C12.7 22 13 21.9 13.2 21.8C13.5 21.5 20.5 15.4 20.5 10C20.5 5.6 16.9 2 12.5 2ZM12.5 19.7C10.4 17.7 6.5 13.4 6.5 10C6.5 6.7 9.2 4 12.5 4C15.8 4 18.5 6.7 18.5 10C18.5 13.3 14.6 17.7 12.5 19.7ZM12.5 6C10.3 6 8.5 7.8 8.5 10C8.5 12.2 10.3 14 12.5 14C14.7 14 16.5 12.2 16.5 10C16.5 7.8 14.7 6 12.5 6ZM12.5 12C11.4 12 10.5 11.1 10.5 10C10.5 8.9 11.4 8 12.5 8C13.6 8 14.5 8.9 14.5 10C14.5 11.1 13.6 12 12.5 12Z",
    fill: "#1226AA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocation);
export default __webpack_public_path__ + "static/media/icon_location.4829c1d50af735528c819b07409b0343.svg";
export { ForwardRef as ReactComponent };